import { AppHelper } from "../appHelper.js"
import { initEdit, Operation } from "../remindersEdit/edit.js"
import { AppBaseProps, CommonApp } from "../core/components/commonApp.js";
import { Grid } from "../core/components/grid.js";
import { MultipleRadioButtons } from "../core/components/multipleRadioButtons.js";
import { Helper } from "../core/util/helper.js";
import { SheetEventType, Sheet } from "../../siteManagement/sheet.js";
import { General } from "../../siteManagement/general.js";
import { HTTPService, createHtppServiceInstance, JsonResultClass } from "../core/util/httpManager.js";
import { FALayerIcon, FALayerIconPart } from "../core/components/faLayerIcon.js";
import { Config } from "../core/config/config.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { StringKeyDictionary, StringOrDate } from "../commonInterfaces.js";
import React from "react";
import ReactDOM from "react-dom";

const reminderSaved = "onTaskSaved";

export class RemindersApp extends React.Component<RemindersListAppProps, { dataCondition: DataCondition }> {
    private _gridData: Reminder[] = [];
    private _gridRef: Grid = null;

    private _factory = ComponentHelper.createFactory();
    private _selectedItem: Reminder = null;
    common = new AppHelper();
    translations: StringKeyDictionary<string> = null;
    remindersGridOptions: kendo.ui.GridOptions = null;
    editEnabled = false;
    noReminders = true;
    noBookmark = true;


    constructor(props: RemindersListAppProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.state = {
            dataCondition: props.initalDataCondition
        }
        console.log(props)
        this._setEvents();
    }

    private _getGridData = async () => {
        let urlToCall = this.props.reminderMode == ReminderViewMode.Created ? "Tasks/GetCreatedByMe" : "Tasks/GetGridData";
        const result = await HTTPService.get<JsonResultClass<Reminder[]>>(urlToCall, { url: this.props.url, dataCondition: this.state.dataCondition });
        Helper.setArrayValues(this._gridData, result.Data);
        for (let i = 0; i < this._gridData.length; i++) {
            this._gridData[i].FullUrl = window.location.origin + Config.baseUrl + this._gridData[i].RelativeUrl;
            if (Helper.hasValue(this._gridData[i].DueDate)) {
                this._gridData[i].DueDate = Helper.dates.toDate(this._gridData[i].DueDate);
            }
            if (Helper.hasValue(this._gridData[i].DateAdded)) {
                this._gridData[i].DateAdded = Helper.dates.toDate(this._gridData[i].DateAdded);
            }
            if (Helper.hasValue(this._gridData[i].ReadAt)) {
                this._gridData[i].ReadAt = Helper.dates.toDate(this._gridData[i].ReadAt);
            }
        }
        this.setState({});
    }

    private _selectionChanged = (dataItem) => {
        const prevEditEnabled = this.editEnabled;
        this.editEnabled = Helper.hasValue(dataItem);
        this._selectedItem = dataItem;
        if (prevEditEnabled !== this.editEnabled) {
            this.setState({});
        }
    }


    createGrid = () => {
        const props = this._factory.getDefaultMultipleRadioButtonsProps();
        props.dataSource = [
            { value: DataCondition.AssignedToMe, text: Helper.getTranslation("WebSMS.Reminder.DataCondition.AssignToMe") },
            { value: DataCondition.CreatedByMe, text: Helper.getTranslation("WebSMS.Reminder.DataCondition.CreatedByMe") },
            
        ];
        if(this.props.showAllBtn){
            props.dataSource.push({ value: DataCondition.All, text: Helper.getTranslation("WebSMS.Reminder.DataCondition.All") })
        }
        props.field.dataTextField = "text";
        props.field.dataValueField = "value";
        props.value = this.state.dataCondition
        props.onChange = (_, value: DataCondition) => {
            this.setState({ dataCondition: value }, this._getGridData)
        }

        return (
            <div className="flex-container">
                <div style={{ padding: "2px 10px" }} >
                    <MultipleRadioButtons {...props} />
                </div>
                <div className="flex-container__item flex-containter" >
                    <Grid data={this._gridData} options={this.remindersGridOptions} onSelectionChanged={this._selectionChanged} ref={(r) => this._gridRef = r} id="reminders" />
                </div>
            </div>
        );
    }

    edit = () => {
        let triggerSaved = false;
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(this.translations["WebSMS.Reminder.Edit"]);
        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
            triggerSaved = true;
            //this._getGridData();
        });
        //sheet.bind(SheetEventType.ItemDeleted, (target) => {
        //    this._getGridData();
        //});
        sheet.bind(SheetEventType.Close, () => {
            this.common.sheetWrapper.trigger(SheetEventType.Custom, { event: reminderSaved, hasChanges: triggerSaved });
        })

        sheet.show(() => {
            initEdit({
                sheet: sheet,
                reminderId: this._selectedItem.ISGuid,
                operation: Operation.Edit,
            });
        });
    }

    add = () => {
        General.Functions.Reminders.QuickAdd();
    }

    private _setEvents = () => {
        $(window).on("refreshReminders", this._getGridData);
    }

    componentDidMount() {
        this._getGridData();
    }

    componentWillUnmount() {
        $(window).off("refreshReminders", this._getGridData);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
};

export enum DataCondition {
    AssignedToMe = 0,
    CreatedByMe = 1,
    All = 2
}

export class EntityReminders extends React.Component<EntityRemindersProps, EntityRemindersState> {
    private _sheet: Sheet = null;
    private _intervalHandle: number = null;


    constructor(props: EntityRemindersProps) {
        super(props);

        let relativeUrl = (window.location.pathname.replace(Config.baseUrl, '') + window.location.search);
        this.state = {
            total: 0,
            unseen: 0,
            url: Helper.hasValue(props.url) ? props.url : relativeUrl
        };

        this._sheet = General.Sheet.Manager.getTopMostSheet();

        this._intervalHandle = window.setInterval(this._refresh, 60000);
        this._refresh();
        $(window).on("refreshReminders", this._refresh);
    }


    private _refresh = () => {
        createHtppServiceInstance().noBusyIndicator().get<JsonResultClass<{ total: number; unseen: number; }>>("Tasks/GetTasksCount", { url: this.state.url })
            .then(result => {
                if (result.Data) {
                    this.setState({ total: result.Data.total, unseen: result.Data.unseen });
                }
            });
    }

    private _onClick = () => {
        const sheet = General.Sheet.Manager.createSheetWithUrl("Tasks/Index?url=" + encodeURIComponent(this.state.url));
        sheet.bind(SheetEventType.Custom, data => {
            if (data.event === reminderSaved && data.hasChanges === true) {
                this._refresh();
            }
        })
    }

    componentWillUnmount() {
        clearInterval(this._intervalHandle);
        $(window).off("refreshReminders", this._refresh);
    }

    render() {
        const icons: FALayerIconPart[] = [
            {
                name: "bookmark",
                attributes: ["2x"]
            }
        ];

        if (this.state.total !== 0) {
            icons.push({
                isText: true,
                attributes: ["fw", "2x"],
                name: `${this.state.unseen}/${this.state.total}`,
                style: { backgroundColor: "var( --primary-color)", color: "white", padding: "5px", borderRadius: "100%", transform: "translate(calc(-50% + -0.225em), calc(-50% + 0.3em)) scale(0.6875, 0.6875) rotate(0deg)", position: "absolute" }
            });
        }

        return (
            ReactDOM.createPortal(
                <div onClick={this._onClick}>
                    <FALayerIcon icons={icons} />
                </div>,
                this._sheet.elements.getRemindersRef()[0]
            )
        );
    }
}


export interface EntityRemindersProps {
    url?: string;
}

interface EntityRemindersState {
    total: number;
    unseen: number;
    url: string;
}

export interface Reminder {
    Id: number;
    Level: number;
    Url: string;
    RelativeUrl: string;
    FullUrl: string;
    AddedBy: string;
    Owner: string;
    Comment: string;
    Resolved?: boolean;
    DateAdded?: StringOrDate;
    DueDate?: StringOrDate;
    IsPrivate?: boolean;
    Context: string;
    ContextKey: string;
    ReadAt?: StringOrDate;
    ISGuid: string;
}

export enum ReminderViewMode {
    Created,
    Assigned
}

export interface RemindersListAppProps extends AppBaseProps {
    url?: string;
    reminderMode: ReminderViewMode;
    initalDataCondition: DataCondition;
    showAllBtn: boolean;
}